import axios from "axios";

export default axios.create({
    //baseURL: "https://dev.oceanademo.com",
    baseURL: window.location.origin,
    //baseURL: "http://localhost:8080",
    withCredentials: false,
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});
